import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { SimPseudoCheckboxComponent } from './pseudo-checkbox.component';

@NgModule({
  declarations: [SimPseudoCheckboxComponent],
  imports: [CommonModule],
  exports: [SimPseudoCheckboxComponent]
})
export class SimPseudoCheckboxModule {}
